export default __webpack_public_path__ + "static/media/ic-duplicate.db75071b.svg";